import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RydeUiUnit } from "@ryde/shared";

import { getPermissionStateTranslationKey } from "./audit-log-permission-state.utils";

/** Translates a role permission's granted/revoked state, leaving every other property value untouched. */
export const useAuditLogPermissionState = ({
  entity,
  path,
}: {
  entity?: RydeUiUnit;
  path: string;
}): { getPermissionStateText: (value: string) => string } => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const getPermissionStateText = (value: string): string => {
      const translationKey = getPermissionStateTranslationKey({
        entity,
        path,
        value,
      });

      return translationKey && i18n.exists(translationKey)
        ? t(translationKey)
        : value;
    };

    return { getPermissionStateText };
  }, [entity, path, i18n, t]);
};
